import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { FieldsetCompletion } from 'types'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface Props {
  id: number
}

export const fetchFieldsetCompletion = async (id: number, workspaceId: number) => {
  const result = await sendToApi<{ fieldset_completion: FieldsetCompletion }>(
    `/w/${workspaceId}/fieldset_completions/${id}`,
  )

  if (result.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }
  return result.data
}

export const useFieldsetCompletion = (
  { id }: Props,
  options?: UseQueryOptions<{ fieldset_completion: FieldsetCompletion }>,
) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  return useQuery<{ fieldset_completion: FieldsetCompletion }>(
    ['fieldsetCompletions', id],
    () => fetchFieldsetCompletion(id, currentWorkspaceId),
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}

export const useFieldsetCompletionWithVoiceOrTone = (
  { id }: Props,
  options?: Omit<UseQueryOptions<{ fieldset_completion: FieldsetCompletion }>, 'select'>,
) =>
  useFieldsetCompletion(
    { id },
    {
      select: (data) => {
        const { completed_fields } = data.fieldset_completion
        const { tone, ...completedFields } = completed_fields
        const toneCompletedField = completed_fields.brand_voice_id || !tone ? {} : { tone }
        return {
          fieldset_completion: {
            ...data.fieldset_completion,
            completed_fields: { ...completedFields, ...toneCompletedField },
          },
        }
      },
      ...options,
    },
  )
